import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CartItemPhotoPreview from '../../../../../../../../../services/checkout/components/CheckoutCartItem/CartItemPhotoPreview';
import Badge from '../../../../../../../../../components/global/Badge';
import PriceDisplay from '../../../../../../../../../components/global/PriceDisplay';
import CheckoutItemQuantityInput from '../../../../../../../../../services/checkout/components/CheckoutCartItem/CheckoutItemQuantityInput';
import { REQUIRES_PRINT_PACKAGE_ALERT_MODAL } from '../../../PurchasingOptions/components/RequiresPrintPackageAlert';
import useOpenModal from '../../../../../../../../../hooks/useOpenModal';

const propTypes = {
  readOnly: PropTypes.bool,
  printItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    price: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
    type: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    name: PropTypes.string,
  }).isRequired,
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onToggle: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  cartItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  disabled: PropTypes.bool,
  disabledElement: PropTypes.node,
};

const PrintItemOption = ({
  readOnly,
  printItem,
  photo,
  onToggle,
  onUpdate,
  cartItem,
  inline,
  disabled,
  disabledElement,
}) => {
  const openModal = useOpenModal();
  const classes = classNames({
    'memberships-print-item-option': true,
    'memberships-print-item-option-inline': inline,
  });
  const printSizeName = printItem.type?.name || printItem?.name;

  return (
    <div
      key={printItem.id}
      className={classes}
      data-testid="memberships-print-item-option"
    >
      {photo && (
        <figure className="memberships-print-item-option-thumb">
          <CartItemPhotoPreview photo={photo} />
        </figure>
      )}

      <div className="memberships-print-item-option-content">
        <span className="memberships-print-item-option-name">
          {printSizeName}
        </span>

        <span className="memberships-print-item-option-price">
          <Badge badgeStyle="yellow" className="text-extra-bold">
            <PriceDisplay
              price={printItem.price.value}
              currency={printItem.price.currency}
            />
          </Badge>
        </span>

        {disabled && disabledElement && !readOnly && <>{disabledElement}</>}
      </div>

      {!readOnly && (
        <CheckoutItemQuantityInput
          className="memberships-print-item-option-quantity"
          min={0}
          onChange={value => {
            if (disabled) {
              openModal(REQUIRES_PRINT_PACKAGE_ALERT_MODAL, {
                name: printSizeName,
              });
              return;
            }
            // Toggle in and out of cart
            if (!cartItem || (!!cartItem && value === 0)) {
              onToggle();
              return;
            }

            // Update quantity on existing cart item
            onUpdate(cartItem.id, {
              quantity: value,
            });
          }}
          value={cartItem?.quantity ?? 0}
          label=""
          disabled={disabled}
        />
      )}
    </div>
  );
};

PrintItemOption.propTypes = propTypes;

export default PrintItemOption;
